// Re-export from the TypeScript implementation
export { createClient } from './client.ts'; 